// Generated by CoffeeScript 1.12.7
(function() {
  var VASTAdExtensionChild;

  VASTAdExtensionChild = (function() {
    function VASTAdExtensionChild() {
      this.name = null;
      this.value = null;
      this.attributes = {};
    }

    return VASTAdExtensionChild;

  })();

  module.exports = VASTAdExtensionChild;

}).call(this);



//////////////////
// WEBPACK FOOTER
// ../~/vast-client/dist/extensionchild.js
// module id = 65
// module chunks = 0